import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { API } from "../App";
import { Sparkles, Gift, Target } from "lucide-react";
import DealCard from "../components/DealCard";
import { PRICING_DISCLAIMER } from "../lib/formatSpecial";

const HiddenSpecialsPage = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/featured-deals?limit=50`)
      .then((r) => setDeals(r.data.filter((d) => d.special_offer).slice(0, 12)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-20 min-h-screen bg-slate-50">
      {/* Hero */}
      <section className="bg-[#0A2342] py-16 md:py-24">
        <div className="container-main text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-flex items-center px-4 py-2 bg-[#DE6E4B] rounded-full text-white text-sm font-medium mb-6">
              <Sparkles className="w-4 h-4 mr-2" /> Exclusive Deals
            </span>
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 font-['Playfair_Display']" data-testid="specials-hero-title">
              Hidden Specials This Week
            </h1>
            <p className="text-slate-300 text-base md:text-lg max-w-2xl mx-auto">
              Move-in specials and deals you won't find on Zillow or Apartments.com. These offers are only available through locators like us.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Alert Banner */}
      <section className="bg-[#DE6E4B] py-3">
        <div className="container-main">
          <div className="flex items-center justify-center text-white text-sm">
            <Gift className="w-4 h-4 mr-2" />
            <span className="font-medium">New specials added every week! Contact us to get the full list.</span>
          </div>
        </div>
      </section>

      {/* Deals Grid */}
      <section className="py-16">
        <div className="container-main">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0A2342]" />
            </div>
          ) : deals.length > 0 ? (
            <>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="specials-grid">
              {deals.map((deal, i) => (
                <DealCard key={deal.id || i} deal={deal} index={i} cta="apply" />
              ))}
            </div>
            <p className="mt-4 text-center text-xs text-slate-500" data-testid="pricing-disclaimer">{PRICING_DISCLAIMER}</p>
            </>
          ) : (
            <div className="text-center py-16">
              <Sparkles className="w-12 h-12 text-slate-300 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-[#0A2342] mb-2">No Specials Listed Yet</h3>
              <p className="text-slate-500 mb-6">New deals are added every week. Apply now and we'll send matches as soon as they're available.</p>
              <Link to="/apply" className="btn-primary bg-[#DE6E4B]" data-testid="no-specials-cta">Apply for Concierge</Link>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0A2342] py-16">
        <div className="container-main text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 font-['Playfair_Display']">
            Want Access to ALL Hidden Specials?
          </h2>
          <p className="text-slate-300 mb-8 max-w-xl mx-auto text-sm md:text-base">
            This is just a sample. We track dozens of specials across Houston. Submit your requirements and we'll send you every deal that matches.
          </p>
          <Link to="/apply" className="bg-[#DE6E4B] hover:bg-white hover:text-[#0A2342] text-white font-semibold py-4 px-8 rounded-xl transition-all inline-flex items-center gap-2" data-testid="specials-cta-apply">
            <Target className="w-5 h-5" /> Get My Full Special List
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HiddenSpecialsPage;
